<div fxLayout="column" style="padding:15px;" fxLayoutAlign="center center center">

    <mat-card ngStyle.gt-lg="width:76%;" ngStyle.lg="width:96%;" ngStyle.lt-lg="width:100%;">
        <mat-card-title>
            <app-page-header [title]="pageTitle" action='' subAction='customForm'></app-page-header>

        </mat-card-title>
        <mat-card-content fxLayout="column">

            <div fxLayout="row">
                <div fxLayout="column" fxFlex="100" style="margin-top:20px;">
                    <mat-tab-group style="width:100%;">
                        <mat-tab>
                            <ng-template mat-tab-label>
                                <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif">
                                    Συναίνεσης
                                </div>
                            </ng-template>
                            <!--    Display forms list    -->
                            <div fxLayout="column" style="width:100%;">
                                <div fxLayout="row" fxFlex="grow" style="margin-top: 10px; margin-left:15px;">
                                    <div fxFlex="grow">
                                        <mat-form-field>
                                            <mat-label>Αναζήτηση τίτλου</mat-label>
                                            <label>
                                                <input matInput [(ngModel)]="searchConsentsValue">
                                            </label>
                                            <button mat-button matSuffix mat-icon-button aria-label="search"
                                                    (click)="searchForms(0)">
                                                <mat-icon fxFlexAlign="center" matTooltip="Αναζήτηση">search</mat-icon>
                                            </button>
                                        </mat-form-field>

                                    </div>


                                    <!--  Display Options-->
<!--                                    <button mat-icon-button matTooltip="Προβολή ως λίστα"-->
<!--                                            (click)="setDisplayOption('list');">-->
<!--                                        <mat-icon style="color:var(&#45;&#45;secondaryBlue);">list</mat-icon>-->
<!--                                    </button>-->

<!--                                    <button mat-icon-button matTooltip="Προβολή ως καρτέλες"-->
<!--                                            (click)="setDisplayOption('card');">-->
<!--                                        <mat-icon style="color:var(&#45;&#45;secondaryBlue);">view_list</mat-icon>-->
<!--                                    </button>-->
                                    <!---->


                                </div>

                                <ng-container
                                        *ngIf="consentTableDataSource.data.length > 0 then showForms else nothingToShow"></ng-container>
                                <ng-template #showForms>
                                    <!-- Show as table -->
                                    <div >
                                        <div fxLayout="column">
                                        <div fxLayout="row" fxFlex="grow" [style.max-height.px]="tableHeight" style="overflow-y: auto;">
                                            <mat-table [dataSource]="consentTableDataSource" class="mat-elevation-z1" style="width: 100%;" [style.max-height.px]="tableHeight">

                                                <ng-container matColumnDef="title">
                                                    <mat-header-cell class="tableHeaderCell" fxFlex="25"
                                                                     fxLayoutAlign="start center center" *matHeaderCellDef>
                                                        Τίτλος
                                                    </mat-header-cell>
                                                    <mat-cell class="tableCell" fxFlex="25"
                                                              fxLayoutAlign="start center center"
                                                              *matCellDef="let element"> {{element.title}} </mat-cell>
                                                </ng-container>

                                                <ng-container matColumnDef="created_by_display_name">
                                                    <mat-header-cell class="tableHeaderCell"
                                                                     fxLayoutAlign="start center center" *matHeaderCellDef>
                                                        Δημιουργήθηκε από
                                                    </mat-header-cell>
                                                    <mat-cell class="tableCell" fxLayoutAlign="start center center"
                                                              *matCellDef="let element"> {{element.created_by_display_name}} </mat-cell>
                                                </ng-container>

                                                <ng-container matColumnDef="date_created">
                                                    <mat-header-cell class="tableHeaderCell"
                                                                     fxLayoutAlign="start center center" *matHeaderCellDef>
                                                        Ημ. Δημιουργίας
                                                    </mat-header-cell>
                                                    <mat-cell class="tableCell" fxLayoutAlign="start center center"
                                                              *matCellDef="let element"> {{element.date_created}} </mat-cell>
                                                </ng-container>

                                                <ng-container matColumnDef="isPublished">
                                                    <mat-header-cell fxFlex="5" class="tableHeaderCell"
                                                                     fxLayoutAlign="center center center" *matHeaderCellDef>
                                                        Δημοσιευμένη
                                                    </mat-header-cell>
                                                    <mat-cell fxFlex="5" class="tableCell" fxLayoutAlign="center center center"
                                                              *matCellDef="let element"> {{element.isPublished ? 'ΝΑΙ' : 'OXI'}} </mat-cell>
                                                </ng-container>

                                                <ng-container matColumnDef="has_deadline">
                                                    <mat-header-cell class="tableHeaderCell"
                                                                     fxLayoutAlign="center center center" *matHeaderCellDef>
                                                        Προθεσμία
                                                    </mat-header-cell>
                                                    <mat-cell class="tableCell" fxLayoutAlign="center center center"
                                                              *matCellDef="let element"> {{element.has_deadline ? element.deadline : '-'}} </mat-cell>
                                                </ng-container>

                                                <ng-container matColumnDef="has_max_slots">
                                                    <mat-header-cell fxFlex="5" class="tableHeaderCell"
                                                                     fxLayoutAlign="center center center" *matHeaderCellDef>
                                                        Θέσεις
                                                    </mat-header-cell>
                                                    <mat-cell fxFlex="5" class="tableCell" fxLayoutAlign="center center center"
                                                              *matCellDef="let element"> {{element.has_max_slots ? element.max_slots : '-'}} </mat-cell>
                                                </ng-container>

                                                <ng-container matColumnDef="modified_by_display_name">
                                                    <mat-header-cell class="tableHeaderCell"
                                                                     fxLayoutAlign="start center center" *matHeaderCellDef>
                                                        Ενημερώθηκε από
                                                    </mat-header-cell>
                                                    <mat-cell class="tableCell" fxLayoutAlign="start center center"
                                                              *matCellDef="let element"> {{element.modified_by_display_name}} </mat-cell>
                                                </ng-container>

                                                <ng-container matColumnDef="date_modified">
                                                    <mat-header-cell class="tableHeaderCell"
                                                                     fxLayoutAlign="start center center" *matHeaderCellDef>
                                                        Ημ. Ενημέρωσης
                                                    </mat-header-cell>
                                                    <mat-cell class="tableCell" fxLayoutAlign="start center center"
                                                              *matCellDef="let element"> {{element.date_modified}} </mat-cell>
                                                </ng-container>


                                                <ng-container matColumnDef="actions">
                                                    <mat-header-cell class="tableHeaderCell"
                                                                     fxLayoutAlign="center center center" *matHeaderCellDef>
                                                        Ενέργειες
                                                    </mat-header-cell>
                                                    <mat-cell class="tableCell" fxLayoutAlign="center center center"
                                                              *matCellDef="let element">
                                                        <!--                                                    <mat-icon>more_vert</mat-icon>-->
                                                        <button matTooltip="Προεπισκόπηση" mat-icon-button
                                                                (click)="showConsentForm(element)">
                                                            <mat-icon>visibility</mat-icon>
                                                        </button>
                                                        <button matTooltip="Επεξεργασία" [disabled]="isEditDisabled(element)"
                                                                mat-icon-button (click)="editCustomForm(element)">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                        <button matTooltip="Αντιγραφή" mat-icon-button
                                                                (click)="duplicate(element)">
                                                            <mat-icon>file_copy</mat-icon>
                                                        </button>

                                                        <!--                                                        <button mat-menu-item (click)="publish(element)">-->
                                                        <!--                                                            <mat-icon class="icon">send</mat-icon>&nbsp;Δημοσίευση σε γονείς-->
                                                        <!--                                                        </button>-->

                                                        <button matTooltip="Διαγραφή" [disabled]="element.isPublished"
                                                                mat-icon-button (click)="deleteForm(element)">
                                                            <mat-icon>delete</mat-icon>
                                                        </button>

                                                    </mat-cell>
                                                </ng-container>


                                                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                                                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                                            </mat-table>
                                        </div>

                                        <div fxLayout="row" fxLayoutAlign="end center center"
                                             style="margin-top: 20px;">
                                            <mat-paginator [length]="consentTableDataSource.data.length" [pageSize]="200"
                                                           [pageSizeOptions]="[10, 50, 100, 200]">
                                            </mat-paginator>
                                        </div>
                                        </div>
                                    </div>


<!--                                    <div [hidden]="displayOption === 'list'">-->

<!--                                        <div fxLayoutAlign="flex-start" *ngFor="let form of displayForms" fxLayout="row"-->
<!--                                             style="width:100%;">-->
<!--                                            <div fxFlex="grow" style="width:100%;">-->
<!--                                                <app-form-card mode="0" [form]="form"-->
<!--                                                               (duplicateFormEmit)="duplicateFormEmittedFromChild()"-->
<!--                                                               (deleteFormEmit)="deleteFormEmittedFromChild($event)"></app-form-card>-->
<!--                                            </div>-->
<!--                                        </div>-->

<!--                                    </div>-->

                                </ng-template>

                                <ng-template #nothingToShow>
                                    <div fxLayout="column" fxLayoutAlign="center center center">
                                        <!--                                <img src="assets/images/no-forms.png" alt="nothingToShow"/>-->
                                    </div>
                                </ng-template>
                            </div>
                            <!--    -->
                        </mat-tab>
                        <!-- Tab Εγγραφής -->
                        <mat-tab>
                            <ng-template mat-tab-label>
                                <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif">
                                    Εγγραφής
                                </div>
                            </ng-template>
                            <div fxLayout="column" style="width:100%;">
                                <div fxLayout="row" fxFlex="grow" style="margin-top: 10px; margin-left:15px;">
                                    <div fxFlex="grow">
                                        <mat-form-field>
                                            <mat-label>Αναζήτηση τίτλου</mat-label>
                                            <label>
                                                <input matInput [(ngModel)]="searchRegistrationValue">
                                            </label>
                                            <button mat-button matSuffix mat-icon-button aria-label="search"
                                                    (click)="searchForms(3)">
                                                <mat-icon fxFlexAlign="center" matTooltip="Αναζήτηση">search</mat-icon>
                                            </button>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <ng-container
                                        *ngIf="registrationTableDataSource.data.length > 0 then showRegistrations else nothingToShowRegistrations"></ng-container>
                                <ng-template #showRegistrations>
                                    <div>
                                        <div fxLayout="column">
                                        <div fxLayout="row" fxFlex="grow" [style.max-height.px]="tableHeight" style="overflow-y: auto;">
                                            <mat-table [dataSource]="registrationTableDataSource" class="mat-elevation-z1" style="width: 100%;" [style.max-height.px]="tableHeight">

                                                <ng-container matColumnDef="title">
                                                    <mat-header-cell class="tableHeaderCell" fxFlex="25"
                                                                     fxLayoutAlign="start center center" *matHeaderCellDef>
                                                        Τίτλος
                                                    </mat-header-cell>
                                                    <mat-cell class="tableCell" fxFlex="25"
                                                              fxLayoutAlign="start center center"
                                                              *matCellDef="let element"> {{element.title}} </mat-cell>
                                                </ng-container>

                                                <ng-container matColumnDef="created_by_display_name">
                                                    <mat-header-cell class="tableHeaderCell"
                                                                     fxLayoutAlign="start center center" *matHeaderCellDef>
                                                        Δημιουργήθηκε από
                                                    </mat-header-cell>
                                                    <mat-cell class="tableCell" fxLayoutAlign="start center center"
                                                              *matCellDef="let element"> {{element.created_by_display_name}} </mat-cell>
                                                </ng-container>

                                                <ng-container matColumnDef="date_created">
                                                    <mat-header-cell class="tableHeaderCell"
                                                                     fxLayoutAlign="start center center" *matHeaderCellDef>
                                                        Ημ. Δημιουργίας
                                                    </mat-header-cell>
                                                    <mat-cell class="tableCell" fxLayoutAlign="start center center"
                                                              *matCellDef="let element"> {{element.date_created}} </mat-cell>
                                                </ng-container>

                                                <ng-container matColumnDef="isPublished">
                                                    <mat-header-cell fxFlex="5" class="tableHeaderCell"
                                                                     fxLayoutAlign="center center center" *matHeaderCellDef>
                                                        Δημοσιευμένη
                                                    </mat-header-cell>
                                                    <mat-cell fxFlex="5" class="tableCell" fxLayoutAlign="center center center"
                                                              *matCellDef="let element"> {{element.isPublished ? 'ΝΑΙ' : 'OXI'}} </mat-cell>
                                                </ng-container>

                                                <ng-container matColumnDef="has_deadline">
                                                    <mat-header-cell class="tableHeaderCell"
                                                                     fxLayoutAlign="center center center" *matHeaderCellDef>
                                                        Προθεσμία
                                                    </mat-header-cell>
                                                    <mat-cell class="tableCell" fxLayoutAlign="center center center"
                                                              *matCellDef="let element"> {{element.has_deadline ? element.deadline : '-'}} </mat-cell>
                                                </ng-container>

                                                <ng-container matColumnDef="has_max_slots">
                                                    <mat-header-cell fxFlex="5" class="tableHeaderCell"
                                                                     fxLayoutAlign="center center center" *matHeaderCellDef>
                                                        Θέσεις
                                                    </mat-header-cell>
                                                    <mat-cell fxFlex="5" class="tableCell" fxLayoutAlign="center center center"
                                                              *matCellDef="let element"> {{element.has_max_slots ? element.max_slots : '-'}} </mat-cell>
                                                </ng-container>

                                                <ng-container matColumnDef="modified_by_display_name">
                                                    <mat-header-cell class="tableHeaderCell"
                                                                     fxLayoutAlign="start center center" *matHeaderCellDef>
                                                        Ενημερώθηκε από
                                                    </mat-header-cell>
                                                    <mat-cell class="tableCell" fxLayoutAlign="start center center"
                                                              *matCellDef="let element"> {{element.modified_by_display_name}} </mat-cell>
                                                </ng-container>

                                                <ng-container matColumnDef="date_modified">
                                                    <mat-header-cell class="tableHeaderCell"
                                                                     fxLayoutAlign="start center center" *matHeaderCellDef>
                                                        Ημ. Ενημέρωσης
                                                    </mat-header-cell>
                                                    <mat-cell class="tableCell" fxLayoutAlign="start center center"
                                                              *matCellDef="let element"> {{element.date_modified}} </mat-cell>
                                                </ng-container>

                                                <ng-container matColumnDef="actions">
                                                    <mat-header-cell class="tableHeaderCell"
                                                                     fxLayoutAlign="center center center" *matHeaderCellDef>
                                                        Ενέργειες
                                                    </mat-header-cell>
                                                    <mat-cell class="tableCell" fxLayoutAlign="center center center"
                                                              *matCellDef="let element">
                                                        <button matTooltip="Προεπισκόπηση" mat-icon-button
                                                                (click)="showConsentForm(element)">
                                                            <mat-icon>visibility</mat-icon>
                                                        </button>
                                                        <button matTooltip="Επεξεργασία" [disabled]="isEditDisabled(element)"
                                                                mat-icon-button (click)="editCustomForm(element)">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                        <button matTooltip="Αντιγραφή" mat-icon-button
                                                                (click)="duplicate(element)">
                                                            <mat-icon>file_copy</mat-icon>
                                                        </button>
                                                        <button matTooltip="Διαγραφή" [disabled]="element.isPublished"
                                                                mat-icon-button (click)="deleteForm(element)">
                                                            <mat-icon>delete</mat-icon>
                                                        </button>
                                                    </mat-cell>
                                                </ng-container>

                                                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                                                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                                            </mat-table>
                                        </div>

                                        <div fxLayout="row" fxLayoutAlign="end center center"
                                             style="margin-top: 20px;">
                                            <mat-paginator #paginatorRegistrations [length]="registrationTableDataSource.data.length" [pageSize]="200"
                                                           [pageSizeOptions]="[10, 50, 100, 200]">
                                            </mat-paginator>
                                        </div>
                                        </div>
                                    </div>
                                </ng-template>

                                <ng-template #nothingToShowRegistrations>
                                    <div fxLayout="column" fxLayoutAlign="center center center">
                                    </div>
                                </ng-template>
                            </div>
                        </mat-tab>
                        <!-- End Tab Εγγραφής -->
                        <mat-tab *ngIf="localEnvironment.productSchoolId !== 1">
                            <ng-template mat-tab-label>
                                <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif">
                                    Δημόσιες / Ανώνυμες
                                </div>
                            </ng-template>
                            <div fxLayout="column" style="width:100%;">
                                <div fxLayout="row" fxFlex="grow" style="margin-top: 10px; margin-left:15px;">
                                    <div fxFlex="grow">
                                        <mat-form-field>
                                            <mat-label>Αναζήτηση τίτλου</mat-label>
                                            <label>
                                                <input matInput [(ngModel)]="searchAffirmationValue">
                                            </label>
                                            <button mat-button matSuffix mat-icon-button aria-label="search"
                                                    (click)="searchForms(1)">
                                                <mat-icon fxFlexAlign="center" matTooltip="Αναζήτηση">search</mat-icon>
                                            </button>
                                        </mat-form-field>
                                    </div>


                                    <!--  Display Options-->
<!--                                    <button mat-icon-button matTooltip="Προβολή ως λίστα"-->
<!--                                            (click)="setDisplayOption('list');">-->
<!--                                        <mat-icon style="color:var(&#45;&#45;secondaryBlue);">list</mat-icon>-->
<!--                                    </button>-->

<!--                                    <button mat-icon-button matTooltip="Προβολή ως καρτέλες"-->
<!--                                            (click)="setDisplayOption('card');">-->
<!--                                        <mat-icon style="color:var(&#45;&#45;secondaryBlue);">view_list</mat-icon>-->
<!--                                    </button>-->
                                    <!---->
                                </div>

                                <ng-container
                                        *ngIf="displayAffirmations.length > 0 then showAffirmations else nothingToShow"></ng-container>
                                <ng-template #showAffirmations>

                                    <div fxLayout="column" *ngIf="displayOption==='list'">
                                        <div fxLayout="row" [style.max-height.px]="tableHeight" style="overflow-y: auto;">
                                        <mat-table [dataSource]="affirmationTableDataSource" class="mat-elevation-z1" style="width: 100%;" [style.max-height.px]="tableHeight">

                                            <ng-container matColumnDef="title">
                                                <mat-header-cell fxLayoutAlign="start center center" class="tableHeaderCell" *matHeaderCellDef>
                                                    Τίτλος
                                                </mat-header-cell>
                                                <mat-cell class="tableCell" class="mat-cell" fxLayoutAlign="start center center"
                                                          *matCellDef="let element"> {{element.title}} </mat-cell>
                                            </ng-container>

                                            <ng-container matColumnDef="created_by_display_name">
                                                <mat-header-cell fxLayoutAlign="start center center" class="tableHeaderCell" *matHeaderCellDef>
                                                    Δημιουργήθηκε από
                                                </mat-header-cell>
                                                <mat-cell class="tableCell" fxLayoutAlign="start center center"
                                                          *matCellDef="let element"> {{element.created_by_display_name}} </mat-cell>
                                            </ng-container>

                                            <ng-container matColumnDef="date_created">
                                                <mat-header-cell fxLayoutAlign="start center center" *matHeaderCellDef>
                                                    Ημ. Δημιουργίας
                                                </mat-header-cell>
                                                <mat-cell class="tableCell" fxLayoutAlign="start center center"
                                                          *matCellDef="let element"> {{element.date_created}} </mat-cell>
                                            </ng-container>

                                            <ng-container matColumnDef="isPublished">
                                                <mat-header-cell class="tableHeaderCell" fxLayoutAlign="center center center" *matHeaderCellDef>
                                                    Δημοσιευμένη
                                                </mat-header-cell>
                                                <mat-cell class="tableCell" fxLayoutAlign="center center center"
                                                          *matCellDef="let element"> {{element.isActive ? 'ΝΑΙ' : 'OXI'}} </mat-cell>
                                            </ng-container>

                                            <ng-container matColumnDef="has_deadline">
                                                <mat-header-cell class="tableHeaderCell" fxLayoutAlign="center center center" *matHeaderCellDef>
                                                    Προθεσμία
                                                </mat-header-cell>
                                                <mat-cell class="tableCell" fxLayoutAlign="center center center"
                                                          *matCellDef="let element"> {{element.has_deadline ? element.deadline : '-'}} </mat-cell>
                                            </ng-container>

                                            <ng-container matColumnDef="has_max_slots">
                                                <mat-header-cell class="tableHeaderCell" fxLayoutAlign="center center center" *matHeaderCellDef>
                                                    Αριθμός θέσεων
                                                </mat-header-cell>
                                                <mat-cell class="tableCell" fxLayoutAlign="center center center"
                                                          *matCellDef="let element"> {{element.has_max_slots ? element.max_slots : '-'}} </mat-cell>
                                            </ng-container>

                                            <ng-container matColumnDef="modified_by_display_name">
                                                <mat-header-cell class="tableHeaderCell" fxLayoutAlign="start center center" *matHeaderCellDef>
                                                    Ενημερώθηκε από
                                                </mat-header-cell>
                                                <mat-cell class="tableCell" fxLayoutAlign="start center center"
                                                          *matCellDef="let element"> {{element.modified_by_display_name}} </mat-cell>
                                            </ng-container>

                                            <ng-container matColumnDef="date_modified">
                                                <mat-header-cell class="tableHeaderCell" fxLayoutAlign="start center center" *matHeaderCellDef>
                                                    Ημ. Ενημέρωσης
                                                </mat-header-cell>
                                                <mat-cell class="tableCell" fxLayoutAlign="start center center"
                                                          *matCellDef="let element"> {{element.date_modified}} </mat-cell>
                                            </ng-container>


                                            <ng-container matColumnDef="actions">
                                                <mat-header-cell fxFlex="15" class="tableHeaderCell" fxLayoutAlign="center center center" *matHeaderCellDef>
                                                    Ενέργειες
                                                </mat-header-cell>
                                                <mat-cell fxFlex="15" class="tableCell" fxLayoutAlign="start center center" *matCellDef="let element">

                                                    <button matTooltip="Προεπισκόπηση" mat-icon-button
                                                            (click)="showConsentForm(element)">
                                                        <mat-icon>visibility</mat-icon>
                                                    </button>

                                                    <button matTooltip="Δημοσίευση" mat-icon-button
                                                            (click)="publishForm(element)">
                                                        <mat-icon>upload</mat-icon>
                                                    </button>

                                                    <button *ngIf="element.isActive" matTooltip="Ορατή" mat-icon-button
                                                            (click)="updateFormStatus(element.id, 0)">
                                                        <mat-icon>published_with_changes</mat-icon>
                                                    </button>

                                                    <button *ngIf="!element.isActive" matTooltip="Μη ορατή" mat-icon-button
                                                            (click)="updateFormStatus(element.id,1)">
                                                        <mat-icon>unpublished</mat-icon>
                                                    </button>


                                                    <button matTooltip="Επεξεργασία" [disabled]="isEditDisabled(element)"
                                                            mat-icon-button>
                                                        <mat-icon>edit</mat-icon>
                                                    </button>

                                                    <button matTooltip="Αντιγραφή συνδέσμου" (click)="copyLink(element)" mat-icon-button>
                                                        <mat-icon>link</mat-icon>
                                                    </button>

                                                    <button matTooltip="Διαγραφή" [disabled]="element.isActive"
                                                            mat-icon-button>
                                                        <mat-icon>delete</mat-icon>
                                                    </button>

                                                </mat-cell>
                                            </ng-container>


                                            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                                            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                                        </mat-table>
                                        </div>
                                        <div fxLayout="row" fxLayoutAlign="end center center"
                                             style="margin-top: 20px;">
                                            <mat-paginator #paginatorAffirmations
                                                           [length]="affirmationTableDataSource.data.length"
                                                           [pageSize]="50" [pageSizeOptions]="[10, 50, 100, 200]">
                                            </mat-paginator>
                                        </div>
                                    </div>


                                    <div *ngIf="displayOption==='card'">
                                        <div fxLayoutAlign="flex-start" *ngFor="let form of displayAffirmations"
                                             fxLayout="row"
                                             style="width:100%;">
                                            <div fxFlex="grow" style="width:100%;">
                                                <app-form-card [form]="form" mode="1"
                                                               (duplicateFormEmit)="duplicateFormEmittedFromChild()"
                                                               (deleteFormEmit)="deleteFormEmittedFromChild($event)"></app-form-card>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>

                                <ng-template #nothingToShow>
                                    <div fxLayout="column" fxLayoutAlign="center center center">
                                        <!--                                <img src="assets/images/no-forms.png" alt="nothingToShow"/>-->
                                    </div>
                                </ng-template>
                            </div>

                        </mat-tab>
                    </mat-tab-group>
                </div>
            </div>

            <div fxLayout="row wrap" fxFlex="grow" fxLayoutAlign="start center center" style="margin-top:20px;">

                <!--    Loading-->
                <div *ngIf="isLoading" fxLayout="column" fxLayoutAlign="center" fxFlex="100">
                    <app-skeleton-loading></app-skeleton-loading>
                </div>
                <!---->

            </div>
        </mat-card-content>
    </mat-card>


</div>


